import { cloneDeep } from "lodash";

// Get updated selected values after applying a filter
function getSelectedFilters(selectedFilters, selectedFilter, selectedValues) {
  if (selectedFilters.length) {
    const filterIndex = selectedFilters.findIndex((f) => f.filter.key === selectedFilter.key);
    if (filterIndex > -1) {
      selectedFilters[filterIndex].values = selectedValues;
      return [...selectedFilters];
    } else {
      return [
        ...selectedFilters,
        {
          filter: selectedFilter,
          values: selectedValues,
        },
      ];
    }
  } else {
    return [
      {
        filter: selectedFilter,
        values: selectedValues,
      },
    ];
  }
}

// Get applied filters based on saved filters
function getAppliedFilters(filter, selectedFilters, filters) {
  const selectedIndex = selectedFilters.findIndex((f) => f.filterID === filter.filterID);
  if (selectedIndex > -1) {
    selectedFilters.splice(selectedIndex, 1);
    return [...selectedFilters];
  } else {
    filter.filterSettings.forEach((d) => {
      const filterDetails = filters.find((f) => f.displayName === d.filter.displayName);
      if (filterDetails) {
        d.filter.filterData = filterDetails.filterData;
      }
    });
    return [...selectedFilters, filter];
  }
}

// Get kpi wise filters from applied filters
function getKPIWiseFilters(selectedFilters, viewIDtoKPIMapping, KPIWiseConfigs) {
  if (!selectedFilters.length || !KPIWiseConfigs) return null;
  const combinedFilterMap = new Map();

  selectedFilters.forEach((f) => {
    f.filterSettings.forEach((fs) => {
      combinedFilterMap.set(fs.filter.displayName, {
        filter: fs.filter,
        values: __getCombinedUniqueVals(
          fs.filter.displayName,
          combinedFilterMap,
          "values",
          fs.values
        ),
      });
    });
  });

  const combinedFilters = [...combinedFilterMap.values()];
  const KPIWiseFilters = {};

  combinedFilters.forEach((filter) => {
    filter.filter.filterData.forEach((d) => {
      const kpisForCurrentTable = viewIDtoKPIMapping[d.tableID].filter((k) => {
        return (
          KPIWiseConfigs[k] != undefined &&
          KPIWiseConfigs[k].dimensionConfig.dimensions.find((fd) => fd.key === d.dimensionKey)
        );
      });
      kpisForCurrentTable.forEach((kpi) => {
        if (!KPIWiseFilters[kpi]) {
          KPIWiseFilters[kpi] = {
            filterDimensions: [],
            filterDimensionValues: [],
          };
        }
        KPIWiseFilters[kpi].filterDimensions.push(d.dimensionKey);
        KPIWiseFilters[kpi].filterDimensionValues.push(filter.values);
      });
    });
  });

  return KPIWiseFilters;
}

// Get combined unique values from a map value item
function __getCombinedUniqueVals(key, map, keyToCombine, keyToCombineValue) {
  if (map.has(key)) {
    const existingKeys = map.get(key)[keyToCombine];
    return [...new Set([...existingKeys, ...keyToCombineValue])];
  } else {
    return keyToCombineValue;
  }
}

function getAppliedGloalFilters(
  selectedGlobalFilter,
  filters,
  defaultFilter,
  isApplicableToWidget
) {
  let selectedFilters = [];
  if (defaultFilter != null) {
    defaultFilter.filterSettings.forEach((d) => {
      const filterDetails = filters.find((f) => f.displayName === d.filter.displayName);
      if (filterDetails) {
        d.filter.filterData = filterDetails.filterData;
      }
    });
    selectedFilters = [...selectedFilters, defaultFilter];
  }
  if (selectedGlobalFilter != null && isApplicableToWidget) {
    const thisGlobalFilter = cloneDeep(selectedGlobalFilter);
    thisGlobalFilter.filterSettings.forEach((d) => {
      const filterDetails = filters.find((f) => f.displayName === d.filter.displayName);
      if (filterDetails) {
        d.filter.filterData = filterDetails.filterData;
      }
    });
    selectedFilters = [...selectedFilters, thisGlobalFilter];
  }
  return selectedFilters;
}

export { getSelectedFilters, getAppliedFilters, getKPIWiseFilters, getAppliedGloalFilters };
